export default __webpack_public_path__ + "static/media/img5.23cba385.jpeg";